import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', () => {
    // Exclude --cta variant (initialized in homepage.js) and other Splide instances
    document.querySelectorAll('.c-locations-slideshow:not(.c-locations-slideshow--cta)').forEach(function (splideElement) {
        new Splide(splideElement, {
            fixedWidth: '100%',
            fixedHeight: '67rem',
            rewind: true,
            pagination: false,
            arrows: true,
            cover: true,
            breakpoints: {
                1024: {
                    fixedHeight: '32.3rem',
                },
            },
        }).mount();
    });
});
